import { Injectable } from '@angular/core';
import { IUser } from '../../classes/user.class';
import { Subject } from 'rxjs';
import { EncryptDecryptService } from '../encrypt-decrypt.service';

@Injectable({
  providedIn: 'root',
})
export class LoggedInUserService {
  $loggedInUserUpdated = new Subject<any>();
  $languageChanged = new Subject<any>();
  loggedInUser: any = null;
  listNavItems: any[] = [];

  public flags = [
    { name: 'Español', image: 'assets/images/flags/es.svg', lang: 'es' },
    { name: 'English', image: 'assets/images/flags/en.svg', lang: 'en' },
  ];

  constructor(private encryptService: EncryptDecryptService) {
    this.loggedInUser = this._getDataFromStorage('user')?.profile;
  }

  public setNewProfile(profile) {
    let dataValue = this._getDataFromStorage('user') || {};
    dataValue.profile = Object.assign(dataValue.profile, profile);
    this._setDataToStorage('user', JSON.stringify(dataValue));
    this.loggedInUser = dataValue.profile;
    this.$loggedInUserUpdated.next(this.loggedInUser);
  }

  public getLanguage() {
    return JSON.parse(localStorage.getItem('language'));
  }

  public getLoggedInUser(): any {
    let data = this._getDataFromStorage('user');
    data = data ? data.profile : null;
    return data;
  }
  public getTokenOfUser(): any {
    let data = this._getDataFromStorage('user');
    data = data ? data.Authorization : null;
    return data;
  }

  public setLoggedInUser(user: any) {
    this.loggedInUser = user;
  }

  public updateUserProfile(user) {
    let dataString: string;
    let dataUser = this._getDataFromStorage('user');
    // dataUser =>{
    //   profile:'...',
    //   Authorization:''
    // }
    let tempdata = dataUser || {};
    if (user) {
      tempdata = { ...tempdata, ...user };
    } else {
      tempdata = null;
    }
    dataString = JSON.stringify(tempdata);
    this._setDataToStorage('user', dataString);
    this.loggedInUser = tempdata?.profile;
    this.$loggedInUserUpdated.next(this.loggedInUser);
  }

  public hasRolUser(...args: any[]) {
    let roleTypes = [...args];
    for (let type of roleTypes) {
      if (type.constructor != String) {
        console.log(`Al llamar la función de check de roles, los argumentos deben ser strings`);
        return false;
      }
    }
    const user = this.getLoggedInUser();
    if (!user) {
      return false;
    }
    let flag = false;
    for (let role of user?.Roles) {
      let findIndex = roleTypes.findIndex((i) => i == role.name);
      if (findIndex > -1) {
        flag = true;
        return flag;
      }
    }
    return flag;
  }

  processPermission(user) {
    let permissionNamesArray: any[] = user?.permissionNames || [];
    let Permission = user?.Permission || {};
    permissionNamesArray.forEach((x) => {
      Permission[x] = true;
    });
    user.Permission = { ...Permission };
    return user;
  }

  public hasPermissions(...args) {
    let operation = args?.[args?.length - 1] == '||' ? '||' : '&&';
    let initial = operation == '||' ? 0 : 1;
    return (
      args.reduce((acc, curr) => {
        return operation == '||' ? acc || this.loggedInUser?.Permission[curr] : acc && this.loggedInUser?.Permission[curr];
      }, initial) || false
    );
  }

  public getlaguages() {
    return this.flags;
  }

  public _getDataFromStorage(key) {
    let data = localStorage.getItem(key);
    if (data == undefined || data == '') {
      return undefined;
    }
    try {
      let dataOutput = this.encryptService.decrypt(data);
      return JSON.parse(dataOutput);
    } catch (error) {
      localStorage.removeItem(key);
      return undefined;
    }
  }

  public _setDataToStorage(key, stringData) {
    try {
      let dataOutput = this.encryptService.encrypt(stringData || '');
      localStorage.setItem(key, dataOutput);
    } catch (error) {
      alert(error);
    }
  }

  public getAgencyId() {
    let user = this.getLoggedInUser();
    return user?.AgencyUser?.[0]?.AgencyId;
  }
  public getAgency() {
    let user = this.getLoggedInUser();
    return user?.AgencyUser?.[0]?.Agency;
  }
  public setAgency(agency) {
    let user = this.getLoggedInUser();
    try {
      user.AgencyUser[0].Agency = agency;
      this.updateUserProfile({ profile: user });
    } catch (error) {
      alert(`Error editando agencia:${error}`);
    }
  }
}
